module.exports = __webpack_public_path__ + "static/img/190927-wearing-mask.e89d3cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190927-wearing-mask.jpg
// module id = ny9q
// module chunks = 0